<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" :aria-hidden="!this.visible">
      <div
        class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <section class="modal-body search" id="modalDescription">
          <!-- Search bar -->
          <div>
            <label for="search">{{ labels.SEN_GUIDA_SEARCH_LABEL }}</label>
            <div>
              <input
                type="search"
                id="search"
                name="search"
                ref="search"
                @input="checkEmptySearch"
                :placeholder="labels.SEN_GUIDA_SEARCH_PLACEHOLDER"
                v-model="searchInput"
                v-on:keyup.enter.prevent="search"
              />

              <!--<button @click.prevent="search" v-if="!searchInput">-->
              <button  v-if="!searchResult || searchResult.length == 0"
                @click.prevent="search"
                :aria-label="labels.SEN_GUIDA_SEARCH_BUTTON_LABEL">
              </button>

              <button
                v-else
                class="btn-close"
                @click="clearSearch"
                :aria-label="labels.SEN_GUIDA_SEARCH_CANCEL_LABEL"
              >
              </button>
            </div>
          </div>
          <!-- END Search bar -->

          <!-- Results -->
          <div v-if="searchResult.length > 0">
            <h3>{{ labels.SEN_GUIDA_SEARCH_MODAL_RESULTS_LABEL }}</h3>

            <!-- Displays only if some search results are found -->
            <div>
              <ul class="results section">
                <li v-for="result in searchResult" :key="result.id">
                  <router-link
                    :to="{ query: result.query }"
                    @click.native="close"
                  >
                    <h4>{{ result.title }}</h4>
                    <p>
                      {{ result.content }}
                    </p>
                  </router-link>
                </li>
              </ul>
            </div>
            <!-- END Displays only if the search terms are found in the topic title keywords -->
          </div>

          <p v-if="searched && searchInput != '' && searchResult.length == 0">
            {{ labels.SEN_GUIDA_SEARCH_NORESULTS }}
          </p>
          <!-- END Results -->
        </section>

        <button
            type="button"
            class="btn-close"
            @click="close"
            :aria-label="labels.SEN_GUIDA_SEARCH_MODAL_CLOSE_LABEL"
          >
          </button>
      </div>
    </div>
  </transition>
</template>

<script>
import labels from "@/data/labels.json";
import lunr from "lunr";
require("lunr-languages/lunr.stemmer.support")(lunr);
require("lunr-languages/lunr.it")(lunr);
import ellipsize from "ellipsize";
import { stripHtml } from "string-strip-html";
import content from "@/data/content";

export default {
  name: "SearchModal",
  props: {
    visible: Boolean,
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.$refs.search.focus();
      }
    },
  },
  created() {
    // handling esc key pressed
    document.addEventListener('keydown', evt => {
      if (evt.key === 'Escape') {
          this.close();
      }
    });

    let loop = (level, content, query = []) => {
      if (content[`level${level}`]) {
        Object.entries(content[`level${level}`]).forEach(([slug, content]) => {
          let actualQuery = [...query];
          actualQuery.push(slug);
          this.searchArray.push({
            id: this.searchArray.length,
            query: actualQuery,
            title: content.label,
            content: content.description,
          });
          loop(level + 1, content, actualQuery);
        });
      }
    };
    loop(1, content);
    const searchArray = this.searchArray;
    this.lunr = lunr(function () {
      this.field("title");
      this.field("content");
      this.ref("id");
      searchArray.forEach(function (doc) {
        this.add(doc);
      }, this);
    });
  },
  mounted() {
    const searchInput = this.$refs.search;
    searchInput.focus();
  },
  methods: {
    close() {
      this.clearSearch();
      this.$emit("close");
    },
    search() {
      this.searched = true;
      let searchResult = this.lunr.search(this.searchInput);
      this.searchResult = searchResult.map((result) => {
        let linkedResult = { ...this.searchArray[result.ref] };
        linkedResult.query = linkedResult.query.reduce((prev, curr, index) => {
          prev["level" + (index + 1)] = curr;
          return prev;
        }, {});

        linkedResult.content = ellipsize(
          stripHtml(linkedResult.content).result,
          150,
          {
            chars: [" "],
          }
        );
        return linkedResult;
      });
    },
    clearSearch() {
      this.searched = false;
      this.searchInput = "";
      this.searchResult = [];
    },
    checkEmptySearch() {
      if (this.searchInput == "")
        this.searched = false;
    }
  },
  data() {
    return {
      labels,
      searchInput: "",
      searched: false,
      searchResult: [],
      searchArray: [],
      lunr: null,
    };
  },
};
</script>

<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  padding: 50px 35px;
  background: var(--SENColor-main);
  color: #fff;
  border-radius: 10px;
  width: 696px;
  max-height: 600px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: auto;
}

.modal-header {
  display: flex;
  color: #fff;
  justify-content: space-between;
}

.modal-body {
  position: relative;
}

.btn-close {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 35px;
  right: 35px;
  border: none;
  padding: 0;
  cursor: pointer;
  font-weight: bold;
  color: #fff;
  background-color: transparent;
  background-image: url("@/assets/images/SEN-modalclose--white.svg");
  background-size: 100%;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}

.modal-body.search > div > div {
  position: relative;
}

.modal-body.search label[for="search"] {
  margin-bottom: 10px;
  display: inline-block;
}

.modal-body.search input[type="search"] {
  width: 100%;
  height: 50px;
  border: 1px solid #fff;
  border-radius: 6px;
  padding: 0 20px;
  margin: 0;
  background-color: transparent;
  display: flex;
  align-items: center;
  font-family: "Poppins";
  font-size: 16px;
}

.modal-body.search input[type="search"],
.modal-body.search input[type="search"]::placeholder {
  color: #ffffff;
}

.modal-body.search input[type="search"] + button {
  position: absolute;
  right: 0;
  top: 0;
  width: 50px;
  height: 50px;
  border: none;
  background-color: transparent;
  background-image: url("@/assets/images/SEN-search--white.svg");
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 20px;
  cursor: pointer;
}

.modal-body.search input[type="search"] + button.btn-close {
  background-image: url("@/assets/images/SEN-modalclose--white.svg");
}

.modal-body.search h3 {
  margin: 20px 0;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 400;
  line-height: 18px;
  border-bottom: 1px solid;
}

.modal-body.search h4 {
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
}

.modal-body.search ul {
  padding: 0;
  list-style: none;
}

.modal-body.search ul li + li {
  margin-top: 10px;
}

.modal-body.search ul li a {
  width: 100%;
  min-height: 56px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #fff;
  padding: 0 85px 0 20px;
  box-sizing: border-box;
  color: #fff;
  text-decoration: none;
  transition: color .4s, background-color .4s, background-image .4s;
}

.modal-body.search ul li a:hover {
  background-color: #fff;
  color: var(--SENColor-main);
  background-image: url("@/assets/images/SEN-rightarrow--blue.svg");
  background-repeat: no-repeat;
  /*background-size: 45px 29px;*/
  background-size: 10px 20px;
  background-position: calc(100% - 20px) 50%;
}

.modal-body.search ul li a > * {
  margin: 0;
}

.modal-body.search ul li a > h4 {
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
}

.modal-body.search ul li a > p {
  font-size: 12px;
  font-weight: 300;
  line-height: 18px;
}

.modal-body.search ul li a span.search-match {
  font-weight: 600;
}

/* Overriding default browser styles */
/* clears the ‘X’ from Internet Explorer */
input[type=search]::-ms-clear { display: none; width : 0; height: 0; }
input[type=search]::-ms-reveal { display: none; width : 0; height: 0; }
/* clears the ‘X’ from Chrome */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration { display: none; }
/* END Overriding default browser styles */
</style>
